import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Suspense } from 'react'
import { MainLoader } from 'src/components'

type AppProviderProps = {
  children: React.ReactNode
}

export const AppProvider = ({ children }: AppProviderProps) => {
  const queryClient = new QueryClient()

  return (
    <Suspense fallback={<MainLoader isLoading />}>
      <QueryClientProvider client={queryClient}>
        {process.env.REACT_APP_ENV === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
        {children}
      </QueryClientProvider>
    </Suspense>
  )
}
